<template>
    <div class="DocumentDetailsPagination">
        <NewButton
            class="DocumentDetailsPagination__arrow"
            :class="{ 'DocumentDetailsPagination__arrow--disabled': currentIndex === 0 }"
            :disabled="currentIndex === 0"
            variant="flat"
            color="neutral"
            size="icon-sm"
            @click="handlePrevious"
        >
            <FontAwesomeIcon :icon="faAngleLeft" />
        </NewButton>
        <span class="DocumentDetailsPagination__count">
            {{ currentIndex + 1 }} of {{ totalCount }}
        </span>
        <NewButton
            class="DocumentDetailsPagination__arrow"
            :class="{ 'DocumentDetailsPagination__arrow--disabled': currentIndex === totalCount - 1 }"
            :disabled="currentIndex === totalCount - 1"
            variant="flat"
            color="neutral"
            size="icon-sm"
            @click="handleNext"
        >
            <FontAwesomeIcon :icon="faAngleRight" />
        </NewButton>
    </div>
</template>

<style lang="scss">
.DocumentDetailsPagination {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 20px;
    height: 60px;
    flex: 1;
    min-width: 0;

    &__arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: transparent;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        color: var(--eidTrustGreen);
        transition: all 0.2s ease;
        flex-shrink: 0;

        &:hover:not(&--disabled) {
            background: var(--eidBgGrayTones-lighter);
        }

        &--disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
    }

    &__count {
        font-size: 14px;
        color: var(--eidTechGray);
        white-space: nowrap;
        flex-shrink: 0;
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'next', 'previous' ],
        components: {
            FontAwesomeIcon,
            NewButton,
        },
    })
    export default class DocumentDetailsPagination extends Vue {
        private faAngleLeft = faAngleLeft;
        private faAngleRight = faAngleRight;

        @Prop({ type: Number, required: true })
        private currentIndex!: number;

        @Prop({ type: Number, required: true })
        private totalCount!: number;

        private handlePrevious(): void {
            this.$emit('previous');
        }

        private handleNext(): void {
            this.$emit('next');
        }
    }
</script>
